import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../assets/css/auth.css';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(`/${user.role}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth">
      <aside className="auth-aside">
        <Link to="/" className="auth-brand"><span className="mark" />CopyTrade</Link>
        <div className="auth-aside-body">
          <span className="auth-eyebrow">Welcome back</span>
          <h2 className="auth-headline">Mirror the floor.</h2>
          <p className="auth-sub">
            Sign in to manage your copies, watch live equity, and stay in control of every position.
          </p>
          <ul className="auth-points">
            <li>Real-time copy execution across your brokers</li>
            <li>Risk limits and drawdown caps you control</li>
            <li>Bank-grade encryption on every credential</li>
          </ul>
        </div>
        <span className="auth-foot">Trading involves substantial risk of loss.</span>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <h1>Sign in</h1>
          <p className="auth-card-sub">Enter your credentials to access your dashboard.</p>

          {error && <div className="auth-alert">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
            <div className="auth-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="auth-input"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div className="auth-row">
            <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
            <Link to="/" className="auth-link auth-aside-link">← Back home</Link>
          </div>

          <p className="auth-switch">
            Don't have an account? <Link to="/register" className="auth-link">Create one</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
